const locale = {
  placeholder: 'Избор на час',
};

export default locale;
